import { BackgroundExportTypes } from 'further-types/background-exports';
import { BackgroundExportTypeLabels } from '../../labels';
import { CalendarTime } from 'utils';

const getDownloadTitle = (download: {
  exportType?: BackgroundExportTypes;
  createdAt?: CalendarTime;
  firmName?: string;
}) => {
  if (!download.exportType || !download.createdAt) {
    return '';
  }

  const time = download.createdAt.toLabel('N/A', 'HH:mm');

  return `${BackgroundExportTypeLabels[download.exportType]} - ${time}`;
};

export default getDownloadTitle;
